import CountryList from '../../slices/master/country/CountryList'
import CountryDetails from "../../slices/master/country/CountryDetails"
import CourseList from '../../slices/master/course/CourseList'
import CourseDetails from "../../slices/master/course/CourseDetails"
import CourseBySessionSlice from '../../slices/master/course/CourseBySession'
import CourseByHeadofficeCourseIdSlice from '../../slices/master/course/CourseByHeadofficeCourseId'
import SubjectsByCourseIdsSlice from '../../slices/master/course/SubjectsByCourseIds'
import StateList from '../../slices/master/state/StateList'
import StateDetails from '../../slices/master/state/StateDetails'
import StatebyCountry from '../../slices/master/state/StatebyCountry'
import CityList from '../../slices/master/city/CityList'
import CityDetails from '../../slices/master/city/CityDetails'
import CityByState from '../../slices/master/city/CityByState'
import DistrictList from '../../slices/master/district/DistrictList'
import DistrictDetails from '../../slices/master/district/DistrictDetails'
import DistrictbyState from '../../slices/master/district/DistrictbyState'
import TehsilList from '../../slices/master/tehsil/TehsilList'
import TehsilDetails from '../../slices/master/tehsil/TehsilDetails'
import TehsilbyDistrict from '../../slices/master/tehsil/TehsilbyDistrict'
import SessionList from '../../slices/master/session/SessionList'
import SessionDetails from '../../slices/master/session/SessionDetails'
import SemesterList from '../../slices/master/semester/SemesterList'
import SemesterDetails from '../../slices/master/semester/SemesterDetails'
import SemesterByCourseSlice from '../../slices/master/semester/SemesterByCourse'
import StudentList from '../../slices/master/student/StudentList'
import StudentDetails from '../../slices/master/student/StudentDetails'
import StudentDetailsByAadhaar from '../../slices/master/student/StudentDetailsByAadhaar'
import StudentRegistration from '../../slices/master/student/StudentRegistration'
import SubjectList from '../../slices/master/subject/SubjectList'
import SubjectDetails from '../../slices/master/subject/SubjectDetails'
import DesignationList from '../../slices/master/designation/DesignationList'
import DesignationDetails from '../../slices/master/designation/DesignationDetails'
import DepartmentList from '../../slices/master/department/DepartmentList'
import DepartmentDetails from '../../slices/master/department/DepartmentDetails'
import SlotList from '../../slices/master/slot/SlotList'
import SlotDetails from '../../slices/master/slot/SlotDetails'
import StaffList from '../../slices/master/staff/StaffList'
import StaffDetails from '../../slices/master/staff/StaffDetails'
import TopicList from '../../slices/master/topic/TopicList'
import TopicDetails from '../../slices/master/topic/TopicDetails'
import TopicQuestions from '../../slices/master/topic/TopicQuestions'
import MasterPaymentList from '../../slices/master/payment/MasterPaymentList'
import MasterPaymentDetails from '../../slices/master/payment/MasterPaymentDetails'
import MasterCouponList from '../../slices/master/coupon/MasterCouponList'
import MasterCouponDetails from '../../slices/master/coupon/MasterCouponDetails'

const masterReducer = {
    courseList: CourseList,
    courseDetails: CourseDetails,
    courseBySession: CourseBySessionSlice,
    courseByHeadofficeCourseId: CourseByHeadofficeCourseIdSlice,
    subjectsByCourseIds: SubjectsByCourseIdsSlice,
    countryList: CountryList,
    countryDetails: CountryDetails,
    stateList: StateList,
    stateDetails: StateDetails,
    statebyCountry: StatebyCountry,
    cityList: CityList,
    cityDetails: CityDetails,
    cityByState: CityByState,
    districtList: DistrictList,
    districtDetails: DistrictDetails,
    districtbyState: DistrictbyState,
    tehsilList: TehsilList,
    tehsilDetails: TehsilDetails,
    tehsilbyDistrict: TehsilbyDistrict,
    sessionList: SessionList,
    sessionDetails: SessionDetails,
    semesterList: SemesterList,
    semesterDetails: SemesterDetails,
    semesterByCourse: SemesterByCourseSlice,
    studentList: StudentList,
    studentDetails: StudentDetails,
    studentDetailsByAadhaar: StudentDetailsByAadhaar,
    studentRegistration: StudentRegistration,
    subjectList: SubjectList,
    subjectDetails: SubjectDetails,
    designationList: DesignationList,
    designationDetails: DesignationDetails,
    departmentList: DepartmentList,
    departmentDetails: DepartmentDetails,
    slotList: SlotList,
    slotDetails: SlotDetails,
    staffList: StaffList,
    staffDetails: StaffDetails,
    topicList: TopicList,
    topicDetails: TopicDetails,
    topicQuestions: TopicQuestions,
    masterPaymentList: MasterPaymentList,
    masterPaymentDetails: MasterPaymentDetails,
    masterCouponList: MasterCouponList,
    masterCouponDetails: MasterCouponDetails,
};

export default masterReducer;